import { useSelector } from 'react-redux';
import { Button, Dropdown, Menu } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import './styles.scss';

const EntityBusinessCaseDropDown = ({
    handleSelectBusinessCase,
    currentBusinessCaseName,
    handleSetCurrentBusinessCaseName,
    entity,
    setHighlightedScenarios,
}) => {
    const businessCases = useSelector((state) => state.business.businessCases);

    const handleSetHighlightedScenarios = (businessCase) => {
        setHighlightedScenarios(businessCase.business_scenario.map((scenario) => scenario.scenario_id));
    };

    const entityBusinessCaseDropDownMenu = () => {
        let entityBusinessCases = businessCases != null ? [...businessCases] : [];

        if (entity != null) {
            entityBusinessCases = [];
            const scenarios = getScenarios(entity, []);

            scenarios.forEach((scenario) => {
                businessCases.forEach((businessCase) => {
                    businessCase.business_scenario.forEach((businessScenario) => {
                        if (scenario.scenario_id === businessScenario.scenario_id) {
                            let isAddBusinessCase = true;

                            entityBusinessCases.forEach((entityBusinessCase) => {
                                if (entityBusinessCase.business_case_id === businessCase.business_case_id) {
                                    isAddBusinessCase = false;
                                }
                            });

                            if (isAddBusinessCase) {
                                entityBusinessCases.push(businessCase);
                            }
                        }
                    });
                });
            });
        }

        return (
            <Menu>
                {entityBusinessCases.map((businessCase, index) =>
                    entityBusinessCaseDropDownMenuItem(businessCase, index),
                )}
            </Menu>
        );
    };

    const getScenarios = (parentNode, nodes) => {
        if (parentNode.length) {
            parentNode.forEach((node) => {
                return getScenarios(node, nodes);
            });
        } else if (parentNode.scenario && parentNode.scenario.length) {
            parentNode.scenario.forEach((entity) => {
                return getScenarios(entity, nodes);
            });
        } else {
            nodes.push(parentNode);
        }
        return nodes;
    };

    const entityBusinessCaseDropDownMenuItem = (businessCase, index) => {
        return (
            <Menu.Item
                onClick={() => {
                    handleSetCurrentBusinessCaseName(businessCase.name);
                    handleSelectBusinessCase(businessCase.business_case_id);
                    handleSetHighlightedScenarios(businessCase);
                }}
                key={businessCase.business_case_id}
            >
                {businessCase.name}
            </Menu.Item>
        );
    };

    return (
        <Dropdown autoFocus={true} selectable={true} overlay={entityBusinessCaseDropDownMenu}>
            <Button
                style={{
                    minWidth: '300.5px',
                    minHeight: '50px',
                    marginLeft: '25px',
                    textAlign: 'center',
                }}
            >
                {currentBusinessCaseName}
                <DownOutlined
                    style={{
                        position: 'absolute',
                        right: '15px',
                        paddingTop: '7.5px',
                    }}
                />
            </Button>
        </Dropdown>
    );
};

export default EntityBusinessCaseDropDown;
